import React from 'react';
import { Loader } from 'src/@vymo/ui/atoms';
import { TileData } from '../../types';
import SpgIcon from '../spgIcon';
import styles from '../../index.module.scss';

function ImageTile({
  data,
  onClick,
  index,
  isLoading,
}: {
  data: { tile: TileData; links: Record<string, any> };
  onClick: (
    data: { tile: TileData; links: Record<string, any> },
    index: number,
  ) => void;
  index: number;
  isLoading;
}) {
  return (
    <div key={data?.tile?.code} className={styles.spg__tile}>
      <div
        className={`${styles.spg__icon} ${styles.spg__icon__image_only}`}
        onClick={() => onClick(data, index)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(data, index);
          }
        }}
        tabIndex={0}
        role="button"
        aria-label={`${data?.tile?.name} tile`}
      >
        {isLoading ? <Loader /> : <SpgIcon icon_uri={data?.tile?.icon_uri} />}
      </div>
    </div>
  );
}

export default ImageTile;
